import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 275,
    transition: "0.5s",
  },
  rootAnimation: {
    "&:hover": {
      transform: "scale(1.03, 1.03)",
    },
  },
  title: {
    fontSize: 14,
  },
  dateText: {
    fontSize: 10,
  },
  image: {
    width: 550,
    height: "auto",
    margin: theme.spacing(6),
  },
  copyButton: {
    marginLeft: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  helpIcon: {
    alignSelf: "center",
    marginLeft: 10,
  },
  flexContainer: {
    display: "flex",
  },
}));

export default useStyles;
